if (!customElements.get('lw-bundle-sizes')) {
  let instance = 0;
  customElements.define('lw-bundle-sizes', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const initialize = () => {
        if (!this.isConnected || this.dataset.enhance !== 'true') return;
        const select = this.querySelector('select[name="id"]');
        const native = this.querySelector('select-element');
        if (!select || !native || !select.options.length) return;
        this.querySelector('.lw-bundle-size-options')?.remove();
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'lw-bundle-size-options';
        const legend = document.createElement('legend');
        legend.textContent = this.dataset.label || 'Size';
        fieldset.append(legend);
        const name = `lw-bundle-size-${++instance}`;
        const radios = [];
        [...select.options].forEach((option, index) => {
          const label = document.createElement('label');
          label.className = 'lw-bundle-size';
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = name;
          input.value = option.value;
          input.id = `${name}-${index}`;
          input.disabled = option.disabled || select.disabled;
          input.checked = option.selected;
          const text = document.createElement('span');
          text.textContent = option.textContent.trim();
          label.append(input, text);
          fieldset.append(label);
          radios.push(input);
          input.addEventListener('change', () => {
            if (!input.checked || input.disabled) return;
            select.value = input.value;
            // Native Sleek handlers retain price updates and variant IDs for cart.
            select.dispatchEvent(new Event('change', {bubbles: true}));
          }, {signal});
        });
        select.addEventListener('change', () => {
          radios.forEach(input => { input.checked = input.value === select.value; });
        }, {signal});
        this.append(fieldset);
        // Retain the select for native cart serialization; hide only after enhancement.
        native.hidden = true;
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true, signal});
      else queueMicrotask(initialize);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
